import React, { SVGProps } from 'react';

const InfoBorder: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 16 16'
        width={16}
        height={16}
        {...props}
    >
        <path
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.5}
            d='M8 10.4V7.7m0-2.09V5.6M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0'
        />
    </svg>
);

export default InfoBorder;
